const languageOptions = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "German",
    value: "de",
  },
  {
    label: "Espanol",
    value: "es",
  },
  {
    label: "Français",
    value: "fr",
  },
  {
    label: "Brazilian Portuguese",
    value: "pt-br",
  },
  {
    label: "Simplified Chinese 简体中文",
    value: "zh-cn",
  },
  {
    label: "Korean - 한국어",
    value: "kr",
  },
  {
    label: "Japanese - 日本語",
    value: "ja",
  },
  {
    label: "Thai - แบบไทย",
    value: "th",
  },
];

const unitOptions = [
  {
    label: "Cm - Kg",
    value: "cm-kg",
  },
  {
    label: "Inch - Lbs",
    value: "inch-lbs",
  },
];

const dateFormatOptions = [
  {
    label: "DD/MM/YYYY",
    value: "%d/%m/%Y",
  },
  {
    label: "DD/MM/YY",
    value: "%d/%m/%y",
  },
  {
    label: "MM/DD/YYYY",
    value: "%m/%d/%Y",
  },
  {
    label: "MM/DD/YY",
    value: "%m/%d/%y",
  },
];

const findOptionByLabel = (options, label) => options.find((item) => item.label === label);

export { languageOptions, unitOptions, dateFormatOptions, findOptionByLabel };
